/** The Pit Board (design.md B14.2): news and patch notes, newest first. */
export const NEWS: { date: string; title: string; body: string }[] = [
  {
    date: '2026-10-14',
    title: 'The Seat Ladder: steal their seat',
    body:
      'Everyone now holds a seat, from the Marlin at the top to the Ferro at the bottom. You start in the Bennet, like 1992. ' +
      'Challenge a driver one tier up: set a lap on the track the game picks, and they get 48 hours to beat it in their faster car or lose the seat. ' +
      'Also new: tap any time on the Records board to race it as a ghost, and use your driver on your phone too (Driver page \u2192 GET A CODE).',
  },
  {
    date: '2026-10-14',
    title: 'Race your friends online',
    body:
      'Head to Head \u2192 PLAY ONLINE gives you a room link to send to up to three friends: they join on their own phone or computer, ' +
      'no sign-up. Pick a straight race or the screen-edge elimination, any track, and add CPUs to fill the grid. ' +
      'If someone\u2019s connection drops, a CPU takes over their car and the race goes on.',
  },
  {
    date: '2026-10-13',
    title: 'Lights out: the Daily Grand Prix',
    body:
      'One track, one car and one twist a day, the same for everybody. Practise as much as you like, then commit to a single ranked lap. ' +
      'Crash and it’s a DNF, just like qualifying in 1992. A new Daily starts at midnight UK time. Keep your streak going ' +
      '(one free pit stop a week covers a missed day) and share your result without spoilers.',
  },
  {
    date: '2026-10-13',
    title: 'Head to Head: 2-4 players, one screen',
    body:
      'The original’s two-player mode, now for up to four. The camera follows the leader: fall off the screen and you lose a light. ' +
      'W A S D, the arrow keys and one gamepad each. Add CPU drivers to fill the grid.',
  },
  {
    date: '2026-10-13',
    title: 'The season: steal their seat',
    body:
      'Six rounds from Phoenix to Rio. Start in the Bennet, challenge a rival in a better car, and take it if you finish ahead. ' +
      'Lose a challenge from below and your seat goes too.',
  },
];
